import React from "react";
import Modal from "react-modal";
import { IoMdClose } from "react-icons/io";
import "./errorModal.css";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.0)", // transparent overlay
    zIndex: 1100,
  },
  content: {
    top: "2.5%",
    left: "auto",
    right: "2.5%",
    bottom: "auto",
    margin: 0,
    transform: "none",
    border: "none",
    background: "#fff",
    padding: "1.2rem 2rem 1.2rem 1.5rem",
    borderRadius: "10px",
    maxWidth: "320px",
    width: "100%",
    minWidth: "220px",
    minHeight: "unset",
    boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
    textAlign: "left",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },
};

Modal.setAppElement("#root");

export default function ErrorModal({ isOpen, onClose, message }) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Error"
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
    >
      <div className="error-modal-content error-modal-topright">
        <div className="error-modal-header">
          <span className="error-modal-title">Error</span>
          <button className="error-modal-close-icon" onClick={onClose} aria-label="Close">
            <IoMdClose size={22} />
          </button>
        </div>
        <div className="error-modal-message">{message}</div>
      </div>
    </Modal>
  );
}
